import React from "react";
import SvgIcon, { SvgIconProps } from "../SvgIcon";
import { default as TikTokIconSrc } from '../assets/tiktok.svg';

export const TikTokIcon = (props: SvgIconProps) => (
  <svg width="21" height="25" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9804 0C15.3765 3.40594 17.2775 5.43654 20.5826 5.65257V9.48335C18.6672 9.67057 16.9894 9.0441 15.038 7.86319V15.0279C15.038 24.1296 5.11545 26.9739 1.12625 20.45C-1.4372 16.252 0.132555 8.88569 8.35578 8.59046V12.6301C7.72931 12.7309 7.05965 12.8893 6.44759 13.0981C4.6186 13.7174 3.5817 14.8767 3.86973 16.9217C4.42418 20.8389 11.6105 21.9982 11.0128 14.3438V0.00720072H14.9804V0Z" fill="#8F8F8F"/>
  </svg>
);